/**
 * 从源对象中，选取只有模板对象的属性，生成新对象
 * @param { Object } template - 模板对象
 * @param { Object } copyed - 源对象
 * @return { Object } 生成的新对象
 * @description 模板：{ name: '', age: '' } 源：{ name: '1', age: '1', sex: 'male' } 返回 { name: '1', age: '1' }
 */
export const copyObject = (template, copyed) => {
    let target = {};
    for (let key in template) {
        if (Object.keys(copyed).includes(key)) {
            switch (typeof copyed[key]) {
                case 'object':
                    target[key] = JSON.parse(JSON.stringify(copyed[key]));
                    break;
                default:
                    target[key] = copyed[key];
            }
        } else {
            target[key] = template[key];
        }
    }
    return target;
}

/**
 * 删除级联数组中特定元素
 * @param { Array } list 级联数组，只支持2级
 * @param { Array } item 被删除元素 格式[id, id]
 * @param { String } children 级联数组子节点
 * @param { String } key 级联数组关键字
 * @param { Boolean } filter 是否清空子节点为空的父级
 */
export const deleteCascaderItem = (list, item, children = 'options', key = 'id', filter = true) => {
    list.some((e, i) => {
        if (e[key] == item[0]) {
            if (e[children]) {
                return e[children].some((ee, ii) => {
                    if (ee[key] == item[1]) {
                        list[i][children].splice(ii, 1);
                        if (filter && e[children].length == 0) {
                            list.splice(i, 1);
                        }
                        return true;
                    } else {
                        return false;
                    }
                })
            } else {
                list.splice(i, 1);
            }
        }
    })
}

// 防抖函数
export const debounce = (fn, time) => {
    let timeout = null;
    return function (...args) {
        timeout && clearTimeout(timeout);
        timeout = setTimeout(() => {
            fn.call(this, args);
        }, time);
    }
}

// 节流函数
export const throttle = (fn, time) => {
    let canRun = true;
    return function (...args) {
        if (!canRun) return;
        canRun = false;
        setTimeout(() => {
            fn.call(this, args);
            canRun = true;
        }, time);
    }
}

// 浏览器全屏
export const fullScreen = (command) => {
    console.log('full screen');
    let fullscreenEnabled = document.fullscreenEnabled ||
        document.mozFullScreenEnabled ||
        document.webkitFullscreenEnabled ||
        document.msFullscreenEnabled;
    if (fullscreenEnabled) {
        let de = document.documentElement;
        if (!command) {
            //关闭全屏
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            }
        } else {
            //打开全屏
            if (de.requestFullscreen) {
                de.requestFullscreen();
            } else if (de.mozRequestFullScreen) {
                de.mozRequestFullScreen();
            } else if (de.webkitRequestFullScreen) {
                de.webkitRequestFullScreen();
            }
        }
    }
}